export default __webpack_public_path__ + "static/media/upgrade.0b5ba1da.svg";